import React from 'react'
import * as Components from 'antd';
import _ from "lodash"


export default ({ onSubmit, ...rest }: any) => <Components.Form {...rest} onFinish={onSubmit} layout={ typeof rest?.layout == 'undefined' ? 'vertical' : rest?.layout} />